import { Box, Button, Divider, Drawer, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { ReactNode } from 'react';

interface FilterDrawerProps {
  open: boolean;
  onClose: () => void;
  onApply: () => void;
  onClear: () => void;
  children: ReactNode;
  title?: string;
}

/** Right-hand filter panel. Callers render their own filter fields as children. */
export function FilterDrawer({
  open,
  onClose,
  onApply,
  onClear,
  children,
  title = 'Filters',
}: FilterDrawerProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: 340 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 1.5 }}>
        <Typography variant="h5" sx={{ flex: 1 }}>
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="Close filters">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Divider />
      <Stack spacing={2.5} sx={{ p: 2, flex: 1, overflow: 'auto' }}>
        {children}
      </Stack>
      <Divider />
      <Box sx={{ display: 'flex', gap: 1, p: 2 }}>
        <Button fullWidth color="inherit" onClick={onClear}>
          Clear all
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={() => {
            onApply();
            onClose();
          }}
        >
          Apply
        </Button>
      </Box>
    </Drawer>
  );
}
